import * as yup from 'yup';
import {
    BILLING_ADDRESS,
    COMPANY,
    CITY,
    CUSTOMER_EMAIL,
    DIFFERENT_DATA,
    FIRST_NAME,
    LAST_NAME,
    POST_CODE,
    STREET,
    STREET_NUMBER,
    TAX_ID_NUMBER,
    SUBORDINATE_INTERNAL_ID,
    PAYER_ADDRESS,
    PAYER_DATA,
    PAYMENT_METHOD,
    PHONE_NUMBER,
    REALIZATION_DATE,
    SCHOOL_EMAIL,
    SHIPPING_ADDRESS,
    SHIPPING_FORM,
    COUNSEL_PARENTS,
    SCHOOL, RECIPIENT_SCHOOL_DATA
} from "views/pages/Checkout/common/constants";

const emailValid = 'Podaj poprawny adres e-mail';
const fieldRequired = 'To pole jest wymagane.';
const phoneNumberValid = 'Podaj poprawny numer telefonu.';
const postCodeValid = 'Podaj poprawny kod pocztowy.';
const taxIdNumberValid = 'Podaj poprawny NIP.';
const charactersMax10Valid = 'Dozwolona liczba znaków to 10.';
const charactersMax50Valid = 'Dozwolona liczba znaków to 50.';
const streetMin2Valid = 'Adres powinien mieć co najmniej 2 znaki';
const numbersNotAllowedValid = 'Cyfry są niedozwolone.';
const subordinateInternalIdValid = 'Wpisany identyfikator JST musi składać się z numeru NIP, myślnika i 5 cyfr.';

export const OrderSchema = (isPromoter: boolean, orderType: string) =>
    yup.object().shape(
        Object.assign(
            {
                [BILLING_ADDRESS]: yup.object().shape(
                    Object.assign(
                        {
                            [COMPANY]: yup
                                .string()
                                .required(fieldRequired)
                                .matches(/^.*[^ ].*$/g, fieldRequired),
                            [CITY]: yup
                                .string()
                                .required(fieldRequired)
                                .matches(/^.*[^ ].*$/g, fieldRequired)
                                .max(50, charactersMax50Valid),
                            [POST_CODE]: yup
                                .string()
                                .required(fieldRequired)
                                .matches(/\d{2}-\d{3}/g, postCodeValid),
                            [STREET]: yup
                                .string()
                                .required(fieldRequired)
                                .matches(/^.*[^ ].*$/g, fieldRequired)
                                .min(2, streetMin2Valid)
                                .max(50, charactersMax50Valid),
                            [STREET_NUMBER]: yup
                                .string()
                                .required(fieldRequired)
                                .matches(/^.*[^ ].*$/g, fieldRequired)
                                .max(10, charactersMax10Valid),
                        },
                        orderType === COUNSEL_PARENTS
                            ? {
                                  [TAX_ID_NUMBER]: yup
                                      .string()
                                      .transform((value) => (value === '' ? undefined : value))
                                      .notRequired()
                                      .matches(/\d{10}/g, taxIdNumberValid),
                              }
                            : {
                                  [TAX_ID_NUMBER]: yup
                                      .string()
                                      .required(fieldRequired)
                                      .matches(/\d{10}/g, taxIdNumberValid),
                              },
                    ),
                ),
                [PAYER_ADDRESS]: yup.object().when(DIFFERENT_DATA, {
                    is: true,
                    then: orderType === SCHOOL
                        ? yup.object()
                        : yup.object().shape(
                            Object.assign({
                                [COMPANY]: yup
                                  .string()
                                  .required(fieldRequired)
                                  .matches(/^.*[^ ].*$/g, fieldRequired),
                                [CITY]: yup
                                  .string()
                                  .required(fieldRequired)
                                  .max(50, charactersMax50Valid)
                                  .matches(/^.*[^ ].*$/g, fieldRequired)
                                  .matches(/^^\D*$/g, numbersNotAllowedValid),
                                [POST_CODE]: yup
                                  .string()
                                  .required(fieldRequired)
                                  .matches(/\d{2}-\d{3}/g, postCodeValid),
                                [SCHOOL_EMAIL]: yup
                                  .string()
                                  .required(fieldRequired)
                                  .email(emailValid),
                                [STREET]: yup
                                  .string()
                                  .required(fieldRequired)
                                  .matches(/^.*[^ ].*$/g, fieldRequired)
                                  .min(2, streetMin2Valid)
                                  .max(50, charactersMax50Valid),
                                [STREET_NUMBER]: yup
                                  .string()
                                  .required(fieldRequired)
                                  .matches(/^.*[^ ].*$/g, fieldRequired)
                                  .max(10, charactersMax10Valid),
                            },
                      orderType === COUNSEL_PARENTS
                            ? {
                              [TAX_ID_NUMBER]: yup
                                .string()
                                .transform((value) => (value === '' ? undefined : value))
                                .notRequired()
                                .matches(/\d{10}/g, taxIdNumberValid),
                            }
                            : {
                              [TAX_ID_NUMBER]: yup
                                .string()
                                .required(fieldRequired)
                                .matches(/\d{10}/g, taxIdNumberValid),
                            },
                    )),
                }),
                [PAYMENT_METHOD]: yup
                    .string()
                    .required(fieldRequired),
                [REALIZATION_DATE]: yup
                    .string()
                    .required(fieldRequired),
                [SHIPPING_ADDRESS]: yup
                    .object()
                    .shape({
                    [COMPANY]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/^.*[^ ].*$/g, fieldRequired),
                    [CITY]: yup
                        .string()
                        .required(fieldRequired)
                        .max(50, charactersMax50Valid)
                        .matches(/^^\D*$/g, numbersNotAllowedValid)
                        .matches(/^.*[^ ].*$/g, fieldRequired),
                    [FIRST_NAME]: yup
                        .string()
                        .required(fieldRequired)
                        .max(50, charactersMax50Valid)
                        .matches(/^^\D*$/g, numbersNotAllowedValid)
                        .matches(/^.*[^ ].*$/g, fieldRequired),
                    [LAST_NAME]: yup
                        .string()
                        .required(fieldRequired)
                        .max(50, charactersMax50Valid)
                        .matches(/^^\D*$/g, numbersNotAllowedValid)
                        .matches(/^.*[^ ].*$/g, fieldRequired),
                    [PHONE_NUMBER]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/\d{9}/g, phoneNumberValid),
                    [POST_CODE]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/\d{2}-\d{3}/g, postCodeValid),
                    [STREET]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/^.*[^ ].*$/g, fieldRequired)
                        .min(2, streetMin2Valid)
                        .max(50, charactersMax50Valid),
                    [STREET_NUMBER]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/^.*[^ ].*$/g, fieldRequired)
                        .max(10, charactersMax10Valid),
                }),
                [SHIPPING_FORM]: yup
                    .string()
                    .required(fieldRequired),
            },
            isPromoter
                ? {
                      [CUSTOMER_EMAIL]: yup
                          .string()
                          .required(fieldRequired)
                          .email(emailValid),
                  }
                : {},
            orderType === SCHOOL ? {
                [PAYER_DATA]: yup.object().shape({
                    [COMPANY]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/^.*[^ ].*$/g, fieldRequired),
                    [CITY]: yup
                        .string()
                        .required(fieldRequired)
                        .max(50, charactersMax50Valid)
                        .matches(/^.*[^ ].*$/g, fieldRequired),
                    [POST_CODE]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/\d{2}-\d{3}/g, postCodeValid),
                    [STREET]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/^.*[^ ].*$/g, fieldRequired)
                        .min(2, streetMin2Valid)
                        .max(50, charactersMax50Valid),
                    [STREET_NUMBER]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/^.*[^ ].*$/g, fieldRequired)
                        .max(10, charactersMax10Valid),
                    [TAX_ID_NUMBER]: yup.string().nullable().when('$payerHasNoNip', {
                        is: true,
                        then: yup.string().nullable().notRequired().transform(() => null),
                        otherwise: yup.string().required(fieldRequired).matches(/\d{10}/g, taxIdNumberValid),
                    }),
                    [SUBORDINATE_INTERNAL_ID]: yup.string().nullable().when('$payerHasNoNip', {
                        is: true,
                        then: yup.string().when('$payerHasNoSubordinateInternalId', {
                            is: true,
                            then: yup.string().nullable().notRequired().transform(() => null),
                            otherwise: yup.string()
                                .required(fieldRequired)
                                .matches(
                                    /\d{10}-\d{5}/g,
                                    subordinateInternalIdValid
                                ),
                        }),
                        otherwise: yup.string().nullable().notRequired().transform(() => null),
                    }),
                }),
                [RECIPIENT_SCHOOL_DATA]: yup.object().shape({
                    [COMPANY]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/^.*[^ ].*$/g, fieldRequired),
                    [CITY]: yup
                        .string()
                        .required(fieldRequired)
                        .max(50, charactersMax50Valid)
                        .matches(/^.*[^ ].*$/g, fieldRequired),
                    [POST_CODE]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/\d{2}-\d{3}/g, postCodeValid),
                    [STREET]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/^.*[^ ].*$/g, fieldRequired)
                        .min(2, streetMin2Valid)
                        .max(50, charactersMax50Valid),
                    [STREET_NUMBER]: yup
                        .string()
                        .required(fieldRequired)
                        .matches(/^.*[^ ].*$/g, fieldRequired)
                        .max(10, charactersMax10Valid),
                    [TAX_ID_NUMBER]: yup.string().nullable().when('$recipientSchoolHasNoNip', {
                        is: true,
                        then: yup.string().nullable().notRequired().transform(() => null),
                        otherwise: yup.string().required(fieldRequired).matches(/\d{10}/g, taxIdNumberValid),
                    }),
                    [SUBORDINATE_INTERNAL_ID]: yup.string().nullable().when('$recipientSchoolHasNoNip', {
                        is: true,
                        then: yup.string().when('$recipientSchoolHasNoSubordinateInternalId', {
                            is: true,
                            then: yup.string().nullable().notRequired().transform(() => null),
                            otherwise: yup.string()
                                .required(fieldRequired)
                                .matches(
                                    /\d{10}-\d{5}/g,
                                    subordinateInternalIdValid
                                ),
                        }),
                        otherwise: yup.string().nullable().notRequired().transform(() => null),
                    }),
                    [SCHOOL_EMAIL]: yup
                        .string()
                        .required(fieldRequired)
                        .email(emailValid),
                }),
            } : {},
        ),
    );
